import styled from 'styled-components';
import media from '../../../utils/media';

export const Wrapper = styled.blockquote`
  position: relative;
  padding-left: 20px;
  margin: 20px;
  border-left: 5px solid #c75212;
  font-size: 1.8em;
  line-height: 1.5em;
  font-family: ${props => props.theme.fonts.montserrat.thin};
`;

export const Body = styled.div`
  display: inline;
  color: #465262;

  &:before,
  &:after {
    color: #c75212;
    font-size: 34px;
    font-family: Calibri;
  }

  &:before {
    content: '”';
  }

  &:after {
    content: '“';
  }

  p {
    display: inline;
    font-size: 27px !important;

    b {
      font-size: inherit !important;
    }
  }
`;

export const Author = styled.cite`
  display: inline;
  font-size: 19px;
  text-align: right;

  &:before {
    content: ' ― ';
  }

  white-space: normal;

  ${media.tablet`
    white-space: nowrap;
  `};
`;
